import { createFileRoute, Outlet } from "@tanstack/react-router";

import { guardModuleRoute } from "@/lib/module-guard";

export const Route = createFileRoute("/orders")({
  beforeLoad: ({ location }) => guardModuleRoute(location.pathname),
  head: () => ({ meta: [{ title: "Orders · AVS Gold ERP" }] }),
  component: () => <Outlet />,
});
